export function changeModalConfigView(state) {
    state.show_modal_config = !state.show_modal_config;
}
export function setBranchOfficeWarehouses(state, data) {
    state.listBranchOfficesWarehouses = data;
}

export function setLines(state, lines) {
    state.lines = lines;
}
export function setBrands(state, brands) {
    state.brands = brands;
}
export function setUsers(state, users) {
    state.users = users.map(p => {
        return { value: p.id, label: p.name + " " + p.surname };
    });
}
export function setProducts(state, products) {
    state.products = products;
}

export function setPhysicalInventory(state, data) {
    if (data) {
        state.physicalInventory = data;
        state.params_config = {
            branch_office_id: data.branch_office_id,
            branch_office_warehouse_id: data.branch_office_warehouse_id,
            sublines: extractIdsFromCategories(data, "sublines"),
            lines: extractIdsFromCategories(data, "lines"),
            brands: extractIdsFromCategories(data, "brands"),
            users: extractIdsFromCategories(data, "users"),
            random_num_prod: data.random_num_prod,
            show_stock_counting: data.show_stock_counting,
            location: data.location,
            location_mode: data.location_mode || "exacta",
            inventory_type: data.inventory_type || "general",
            short_description: data.short_description,
            user_res_id: data.user_res_id
        };
    }
}

export function extractIdsFromCategories(data, category) {
    // Verificamos si la categoría existe en el objeto y si tiene elementos
    if (data[category] && data[category].length > 0) {
        // Utilizamos la función map para crear un nuevo array con solo los IDs
        return data[category].map(item => item.id);
    } else {
        return []; // Si la categoría no existe o no tiene elementos, devolvemos un array vacío
    }
}

export function setLoading(state, data) {
    state.loading.module = data;
}

export function setparamsConfig(state, data) {
    state.params_config = {
        branch_office_id: data.branch_office_id,
        branch_office_warehouse_id: data.branch_office_warehouse_id,
        users: [],
        random_num_prod: null,
        show_stock_counting: false,
        user_res_id: data.user_id,
        only_diferences: true,
        location_mode: "exacta",
        inventory_type: "general"
    };
}

export function setFinalizeInventory(state, data) {
    state.show_pdf = true;
    state.file_name = data.pfd;
    console.log(state.file_name, data);
}

export function clearComponent(state, data = null) {
    state.physicalInventory = {
        id: null,
        state: null
    };
    (state.params_config = {
        branch_office_id: localStorage.selected_branchoffice,
        branch_office_warehouse_id:
            localStorage.selected_branchoffice_warehouse,
        lines: [],
        brands: [],
        users: [],
        random_num_prod: null,
        show_stock_counting: false,
        only_diferences: state.params_config.only_diferences,
        location_mode: "exacta",
        inventory_type: "general"
    }),
        (state.show_pdf = false);
    state.file_name = null;
}

export function setCounts(state, data) {
    state.usersCount = data;
}

export function setCountingStateUsers(state, data) {
    state.counting_state_users = data;
}

export function setProductsPhysicalInventory(state, data) {
    state.productsPhysicalInventory = data;
    state.productsPhysicalInventoryBK = data;
}

export function setProductsPhysicalInventoryUnit(state, data) {
    state.productsPhysicalInventory = data;
}

export function setShortDescriptionList(state, data) {
    state.shortDescriptionList = data;
}

export function addUserResp(state, user_id) {
    if (!state.params_config.users.includes(user_id)) {
        state.params_config.users.push(user_id);
    }
}



// WEBPACK FOOTER //
// ./src/modules/physical-inventory/mutations.js